import React from "react";
import { Moon, Sun } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useTheme } from "@/contexts/ThemeContext";
import { cn } from "@/lib/utils";

interface ThemeToggleProps {
  className?: string;
}

/**
 * Toggle sol / switch / lua — Light + Dark.
 * Sol à esquerda (claro), lua à direita (escuro).
 */
export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className }) => {
  const { isDark, setTheme } = useTheme();

  return (
    <div
      className={cn(
        "flex items-center gap-2 select-none",
        className
      )}
      role="group"
      aria-label="Alternar tema"
    >
      <button
        type="button"
        onClick={() => setTheme("light")}
        className={cn(
          "p-0.5 rounded-md transition-colors duration-200",
          !isDark
            ? "text-[#2563EB]"
            : "text-[#94A3B8] hover:text-[#64748B] dark:text-[#71717A] dark:hover:text-[#A1A1AA]"
        )}
        aria-label="Tema claro"
        title="Tema claro"
      >
        <Sun className="w-[18px] h-[18px]" strokeWidth={1.75} />
      </button>

      <Switch
        checked={isDark}
        onCheckedChange={(checked) => setTheme(checked ? "dark" : "light")}
        className="h-5 w-9"
        aria-label={isDark ? "Tema escuro ativo" : "Tema claro ativo"}
      />

      <button
        type="button"
        onClick={() => setTheme("dark")}
        className={cn(
          "p-0.5 rounded-md transition-colors duration-200",
          isDark
            ? "text-[#60A5FA]"
            : "text-[#94A3B8] hover:text-[#64748B]"
        )}
        aria-label="Tema escuro"
        title="Tema escuro"
      >
        <Moon className="w-[18px] h-[18px]" strokeWidth={1.75} />
      </button>
    </div>
  );
};

export default ThemeToggle;
